import React, { useState } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { 
    acceptUserInvitation, 
    rejectUserInvitation, 
} from '../../actions/reduxActions/organizations';
import PagedTable from '../PagedTable';
import { pathEq } from 'ramda';
import translations from '../../translations';

/**
 * @description Flow Org. User invitation list
 *
 * Display a list of actionable invitations for the current user.
 */
export const CurrentUserInviteList = ({ currentUser, invitations = [], acceptInvitationAction, rejectInvitationAction }) => {
    const [page, setPage] = useState(1);
    const pageSize = 20;
    const pendingInvitations = invitations.filter(
        (item) => {
            const matchingUser = currentUser.id && pathEq(['user', 'id'], currentUser.id, item);
            const actionable = item.status !== 'accepted' && item.status !== 'rejected';
            return matchingUser && actionable;
        },
    );

    return (
        <>
            <p>
                <strong>Invitations for user: </strong>
                {`${currentUser.email}`}
            </p>
            <p className="description">
                {translations.FORG_user_invitations_description}
            </p>
            <PagedTable
                className="table margin-top"
                columns={[
                    {
                        renderHeader: () => 'Actions',
                        renderCell: ({ item }) => (
                            <>
                                <button
                                    className="btn btn-primary"
                                    onClick={() => acceptInvitationAction({
                                        organizationId: item.organization.id,
                                        authenticationToken: currentUser.authenticationToken,
                                        tenantId: currentUser.tenantId,
                                    })}
                                >
                                    Join
                                </button>
                                <button
                                    className="btn btn-danger"
                                    onClick={() => rejectInvitationAction({
                                        organizationId: item.organization.id,
                                        authenticationToken: currentUser.authenticationToken,
                                        tenantId: currentUser.tenantId,
                                    })}
                                >
                                    Reject
                                </button>
                            </>
                        ),
                        size: '165px',
                    },
                    {
                        renderHeader: () => 'Organization',
                        renderCell: ({ item }) => (
                            <span title={`ID: ${item.organization.id}`}>
                                {item.organization.name}
                            </span>
                        ),
                    },
                    {
                        renderHeader: () => 'Status',
                        renderCell: ({ item }) => <span className="capitalize">{item.status}</span>,
                        size: '20%',
                    },
                    {
                        renderHeader: () => 'Date Sent',
                        renderCell: ({ item }) => moment(item.invitedAt).format('lll'),
                        size: '175px',
                    },
                ]}
                items={pendingInvitations}
                page={page}
                pageSize={pageSize}
                onPageClick={setPage}
            />
        </>
    );
};

const mapStateToProps = state => ({
    currentUser: state.currentUser,
});

const mapDispatchToProps = {
    acceptInvitationAction: acceptUserInvitation,
    rejectInvitationAction: rejectUserInvitation,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(CurrentUserInviteList);
